"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ResponsiveContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ResponsiveContext = /*#__PURE__*/_react["default"].createContext(null);
exports.ResponsiveContext = ResponsiveContext;
var _default = ResponsiveContext;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/util/ResponsiveContext.js
// module id = 2704
// module chunks = 0